import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ListsWithNumber } from "../../../../Constant";
import { LIST_NUMBER_DATA, LIST_NUMBER_LIST } from "../../../../Data/UiKit/Lists";
import { LI, OL } from "../../../../AbstractElements";

const ListsWithNumbers = () => {
  return (
    <Col xxl="4" sm="12">
    <Card>
      <CommonCardHeader title={ListsWithNumber} span={LIST_NUMBER_DATA} />
      <CardBody>
        <OL className="list-group list-group-numbered">
          <LI className="txt-primary fw-bold">Known for delivery of useful and usable solutions</LI>
          {LIST_NUMBER_LIST.map(({ color, text }, index) => (
             <LI className={`txt-${color} fw-bold`} key={index}>{text}</LI>
          ))}
        </OL>
      </CardBody>
    </Card>
  </Col>
  )
};

export default ListsWithNumbers;